(() => {
  if (window.eversinceCursorTrail) return;
  window.eversinceCursorTrail = true;

  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const mouse = matchMedia('(any-hover: hover) and (any-pointer: fine)');
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  canvas.setAttribute('aria-hidden', 'true');
  Object.assign(canvas.style, {
    position: 'fixed',
    inset: '0',
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    zIndex: '2147483647',
    mixBlendMode: 'difference'
  });
  document.body.appendChild(canvas);

  const points = [];
  let frame = 0;
  const lifetime = 450;

  function resize() {
    const ratio = Math.min(devicePixelRatio || 1, 2);
    canvas.width = innerWidth * ratio;
    canvas.height = innerHeight * ratio;
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
    points.length = 0;
  }

  function clear() {
    cancelAnimationFrame(frame);
    frame = 0;
    points.length = 0;
    ctx.clearRect(0, 0, innerWidth, innerHeight);
  }

  function draw(now) {
    frame = 0;
    ctx.clearRect(0, 0, innerWidth, innerHeight);

    while (points.length && now - points[0].time > lifetime) {
      points.shift();
    }

    if (points.length > 1) {
      ctx.beginPath();

      const first = points[0];
      const next = points[1];
      const progress = Math.min(
        1,
        Math.max(0, (now - first.time) / lifetime)
      );

      ctx.moveTo(
        first.x + (next.x - first.x) * progress,
        first.y + (next.y - first.y) * progress
      );

      for (let i = 1; i < points.length - 1; i++) {
        const p = points[i];
        const n = points[i + 1];
        ctx.quadraticCurveTo(
          p.x, p.y,
          (p.x + n.x) / 2,
          (p.y + n.y) / 2
        );
      }

      const last = points[points.length - 1];
      ctx.lineTo(last.x, last.y);
      ctx.strokeStyle = '#ffffff';
      ctx.lineWidth = 1;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.stroke();
    }

    if (points.length) frame = requestAnimationFrame(draw);
  }

  window.addEventListener('pointermove', (event) => {
    if (
      event.pointerType !== 'mouse' ||
      motion.matches ||
      !mouse.matches
    ) return;

    points.push({
      x: event.clientX,
      y: event.clientY,
      time: performance.now()
    });

    if (points.length > 200) points.shift();
    if (!frame) frame = requestAnimationFrame(draw);
  }, { passive: true });

  window.addEventListener('resize', resize);
  window.addEventListener('blur', clear);
  document.documentElement.addEventListener('pointerleave', clear);
  document.addEventListener('visibilitychange', clear);
  motion.addEventListener('change', clear);
  mouse.addEventListener('change', clear);

  resize();
})();